import React from "react";

const ChatSection = ({ data }) => {
  return (
    <div>
      {!data?.length ? (
        <></>
      ) : (
        <div className="chat-section">
          {data?.map((chat, index) => (
            <p
              key={index}
              className={`chat-message ${
                chat.from === "admin" ? "admin-message" : "user-message"
              }`}
            >
              {chat.message}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChatSection;
